import { render, staticRenderFns } from "./CouponStoreScan.vue?vue&type=template&id=baa0a8fa&scoped=true&"
import script from "./CouponStoreScan.vue?vue&type=script&lang=js&"
export * from "./CouponStoreScan.vue?vue&type=script&lang=js&"
import style0 from "./CouponStoreScan.vue?vue&type=style&index=0&id=baa0a8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa0a8fa",
  null
  
)

export default component.exports